<div class="datainsight-mn">
  <div class="header-datainsight">
    <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="oi-comen-heading bread-mb dc-heading-mb">
          <div class="row">
             
              <div class="col-md-12">
                  <div class="oi-bread-mn1">
                      <span  class="kh-pointer">Data Insight</span> <i class="fa fa-angle-right"></i>
                      <span>{{Conv_Name}}</span>
                      <span class="st-sales-force-dt" *ngIf="database_name">{{database_name}}</span>

                  </div>

              </div>


          </div>

      </div>
      </div>
    </div>
  </div>
  </div>
  <div class="data-inner-pgg">
  <div class="container-fluid">
 
      <div class="row">
      <div class="col-md-3">
        <div class="data-in-left-mn">
          <div class="data-in-left-inner">
         
          <button class="btn btn-primary newconver-btn" (click)="shownewconnectionmodal()" disabled>+ Create  New Connection form</button> 
          <button class="btn btn-primary newconver-btn" (click)="showConectionmodal()">+ New Conversation</button> 

          <div class="dat-insight-searc">
            <div class="sata-seacrh-insight d-flex justify-content-start" [ngClass]="{'st-error-search': objectKeys.keys(reversedConversations).length == 0 }">   
        
              <input type="text" class="search-control" [(ngModel)]="searchQuery"  (ngModelChange)="searchConversation()" placeholder="Search conversation" >
              <button class="btn search-btn1" >
                <svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
              </button> 
              
              
            
            </div>

            <div *ngIf="objectKeys.keys(reversedConversations).length == 0  && searchQuery">
              <div class="conv-search-error">
                No conversations found for the given keyword
              </div>        
            </div>

            <div class="data-insg-left-heading1"><svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" /><path d="M9.5 9h.01" /><path d="M14.5 9h.01" /><path d="M9.5 13a3.5 3.5 0 0 0 5 0" /></svg> <span>Chat History</span></div>



            <div class="data-insg-side-lt">
              <div *ngIf="objectKeys.keys(reversedConversations).length > 0">
                <div *ngFor="let group of reversedConversations   | keyvalue: compareKeys ">
                  <div class="di-recent-lt">
                    <div class="st-lt-time">{{ group.key }}</div>
                    <ul *ngIf="group.value && group.value.length > 0">
                      <li class="d-flex" *ngFor="let conv of group.value">
                        <div (click)="selectConversation(conv, true)"  class="data-list-txt" [class.active-op]="conv.conversation_id == selectedConversationId">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="">
                            <path d="M8 9h8" />
                            <path d="M8 13h6" />
                            <path d="M9 18h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-3l-3 3l-3 -3z" />
                          </svg>
                          <span>{{ conv.conv_name }}</span>
                        </div>
                       
                        
                        <div class="hs-delte">
                          <div class="dropdown">
                            <button class="hs-dotted dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /></svg>
                            </button>
                            <ul class="dropdown-menu drop-hs">
                              <li (click)="selectConversation(conv, true)" ><svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg> View</li>
                              <li (click)="selectUserPrompt(conv, $event)" >                                 
                                <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor" stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                  <path d="M16 5l3 3" />
                                </svg>
                                User Prompt
                              </li>
                              <li class="dele-color" (click)="deleteConv(conv)"><svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>
                                Delete</li>
                              
                             
                            </ul>
                          </div> 
                         
                        </div>
                      </li>
                    </ul>
                    <p *ngIf="!group.value || group.value.length === 0">
                      No conversations available.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          
          </div>



          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="datainsight-rtl">
         
          <!-- <div class="data-heading1">Chat</div> -->

          <div class="data-insght-chat-mn d-flex align-items-start flex-column" >
          <div class="data-insgt-top">
            <div class="oi-chat-new-scroll" #scrollMe  (scroll)="onScroll()">
              <div class="prev-conv-content">
                <div class="get-ans-history" > 
                <div class="container-fluid" > 
                  <ng-container *ngIf="loader else showcontent">
                    <div class="imgloader" *ngIf="loader">
                      <img src="../../assets/img/loader.gif">
                      <div class="loader-text">Loading....</div>
                    </div>
                  </ng-container>                         
                  <ng-template #showcontent>
                    
                    <div class="row" *ngIf="prevConvesations else noresult">
                      <div class="col-md-12">
                        <div class="st-chat-history" *ngFor="let conversation of prevConvesations,let i=index" [id]="'conversation-' + (conversation.conv_stata_code_id )" >
                        
                          <div *ngIf="conversation.type=='conversation'">
                          <div class="st-chat-inner-right">
                          <div class="st-chat-inner-mn1n d-flex justify-content-end">
                            <!-- <div class="st-chat-user-img"><span>S</span></div> -->
                            <div class="st-chat-message qns-copy-btn">
                              <div class="copybtn-hover">
                                <button class="btn" type="button" (click)="copyQnToclipboard(conversation.question,conversation.conv_detail_id)">
                                <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
                                </button>
                                <span *ngIf="isQnCopied[conversation.conv_detail_id] " class="copied-message3">Copied to clipboard!</span>
                              </div>
                              <!-- <div class="st-qns-h1">You</div> -->
                              <div class="st-qns-p1">{{ conversation.question}}</div>
                            </div> 
        
                          </div>
                          </div>
        
                          <div class="st-chat-inner-left">
                            <div class="st-cht-lft-1i d-flex justify-content-start">
                            <div class="st-chat-user-img1" *ngIf="timer"><span><img src="../../assets/img/user-ai.png"></span></div>
                            <div class="st-chat-message1">
                              
                              <div class="st-chat-message1-inner">
                              <div class="st-message-ai">
                                {{conversation.dataset_description}}

                            <div class="oi-data-tab-view"  *ngIf="conversation.parsedData.length > 0 ">
                            <div class="oi-data-tab-menu">
                                <ul>
                                  <li [class.active]="conversation.activeTab === 'table'"
                                      (click)="onTabClick(conversation, 'table')">Table View</li>

                                  <li [class.active]="conversation.activeTab === 'chart'"
                                      (click)="onTabClick(conversation, 'chart')">Chart View</li>

                                  <li [class.active]="conversation.activeTab === 'smart'"
                                      (click)="onTabClick(conversation, 'smart')">Smart Analysis</li>
                                </ul>

                            </div>


                              <div class="oi-dt-tab-bx1 table-view"  *ngIf="conversation.activeTab === 'table'">
                                  <div class="st-chat-tbl-dv " *ngIf="conversation.parsedData.length > 0">
                            <div class="table-responsive st-table-cht-mn table-active">
                              <table  class="table table-bordered">
                                <thead>
                                  <tr>
                                    <th *ngFor="let header of conversation.headers"><div class="chat-th">{{ header }}</div></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let row of conversation.paginatedData">
                                    <td *ngFor="let cell of row">{{ formatData(cell) }}</td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                            </div>
                
                
                            
                            </div>  
                              </div>
                              
                       <div class="chart-view" *ngIf="conversation.activeTab === 'chart'">
                      <div class="lt-loader" *ngIf="conversation.chartLoading"><img src="../../assets/img/loader-lt.gif"> Loading chart...</div>
                     
                      <div class="refresh-btn" *ngIf="!conversation.chartLoading">
                        <button class="btn btn-refresh"
                              (click)="refreshChart(conversation)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" 
                              viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                              class="feather feather-refresh-cw">
                            <polyline points="23 4 23 10 17 10"></polyline>
                            <polyline points="1 20 1 14 7 14"></polyline>
                            <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l5.36 5.36A9 9 0 0020.49 15"></path>
                          </svg>                          
                        </button>
                      </div>
                      
                      <div *ngIf="!conversation.chartLoading && conversation.hasValidChart">
                        <canvas baseChart
                                [data]="conversation.chartData.data"
                                [options]="conversation.chartData.options"
                                [type]="conversation.chartData.type"
                                style="min-height: 320px;">
                        </canvas>
                      </div>
                      
                      <div *ngIf="!conversation.chartLoading && conversation.hasValidChart === false">
                        No chart data available.
                      </div>
                    </div>



                     <div class="smart-analysis" *ngIf="conversation.activeTab === 'smart'">
                          <div class="lt-loader" *ngIf="conversation.analysisLoading"><img src="../../assets/img/loader-lt.gif"> Loading smart analysis...</div>
                                 
                          <div class="refresh-btn" *ngIf="!conversation.analysisLoading">
                            <button class="btn btn-refresh"
                                  (click)="refreshAnalysis(conversation)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" 
                                  viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                                  class="feather feather-refresh-cw">
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <polyline points="1 20 1 14 7 14"></polyline>
                                <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l5.36 5.36A9 9 0 0020.49 15"></path>
                              </svg>                              
                            </button>
                          </div>

                             <div *ngIf="!conversation.analysisLoading && conversation.hasAnalysis">
                                        <p [innerHTML]="sanitizeMessage(conversation.smartAnalysis,'')"></p>
                                      </div>
                                      
                                      <div *ngIf="!conversation.analysisLoading && conversation.hasAnalysis === false">
                                        No smart analysis available.
                                      </div>
                             </div>



                            </div>            
        
                    
                    
                              </div>
        
                            </div>
                            <div class="st-cht-lt-ai-btn"  *ngIf="conversation.parsedData.length > 0">
                              <div class="container-fluid">
                              <div class="row">
                               <div class="col-md-6">
                                 <div class="st-chat-like-btn">
                       
                                   <button class="btn st-cht-copy" (click)="copyToClipboard(conversation,conversation.conv_detail_id)"
                                   [pTooltip]="isCopied[i] ? 'Copied!' : 'Copy'"><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg> 
                                   <span *ngIf="isCopied[conversation.conv_detail_id] " class="copied-message">Copied to clipboard!</span></button>
                                  
                                   <button class="btn" (click)="downloadprevAnswer(conversation,conversation.dataset_name)">
                                     <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg>
                                   </button>
                                   <button  class="btn sql-drop-btn" [ngClass]="{'btn-sql-hover': conversation.displaySQLmodal}" (click)="openSQLmodal(conversation)">SQL Code <img [src]="conversation.displaySQLmodal ? '../../assets/img/caret-up.svg' : '../../assets/img/caret-down.svg'"></button>                                  
        
                              </div>
                               </div>
        
                               <div class="col-md-6">
                                <div class="st-chat-tble-pagination" *ngIf="conversation.totalPages>1 && conversation.activeTab === 'table'">
                                  <div class="pagination-text">Showing {{ conversation.currentPage }} out of {{ conversation.totalPages }}</div>
                                  <div class="pagination-button">
                                    <button type="button"  (click)="changePage(conversation,'prev')" class="btn btn-pagin-button " [disabled]="conversation.currentPage == 1"  [ngClass]="{'active': conversation.currentPage != 1}">
                                      <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M15 6l-6 6l6 6" /></svg>
                                    </button>
                                    <button type="button" class="btn btn-pagin-button" (click)="changePage(conversation,'next')"  [disabled]="conversation.currentPage === conversation.totalPages" [ngClass]="{'active': conversation.currentPage != conversation.totalPages}">
                                      <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M9 6l6 6l-6 6" /></svg>
                                    </button>
                                  </div>
                                </div>
                               </div>
                               
                              
                              </div>
                         <!-- SQL View Start -->
                       <div class="row">
                        <div class="col-md-12" *ngIf="conversation.displaySQLmodal">                        
                      <div class="sql-modal-custom" >
                        <div class="sql-modal-header">SQL View <span></span> </div>
                        <div class="sql-content-mn">
                          <!-- <h4>SQL Code </h4> -->              
                           <pre><code class="modal-text-n" appHighlight> {{sqlFormatter}} </code></pre>
                          <div class="sql-copy-btm">
                            <button class="btn sql-copy" type="button"[pTooltip]="isCopied[i] ? 'Copied!' : 'Copy'" (click)="copyToClipboard(conversation.response_sql,i)"><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
                              <span *ngIf="isCopied[i]" class="copied-message1">Copied to clipboard!</span>
                            </button>
                          </div>
                        </div>
                       </div>
                       <!-- <div class="sql-drop-bt-txt">Source Links: www.placeholder.com/1233</div> -->

                      </div>
                    </div>
                      <!-- SQL View End -->
                              
                              </div>
                             </div>
                            </div>
                          </div>
                                          
                    
                          </div>
                        </div>
                        </div>
                        
                        
                      </div>
                    </div>
                    
                    <ng-template #noresult>
                      <div class="oi-no-resultfound">
                        <img src="../../assets/img/no-result.png">
                        <h3>Sorry! No result found :</h3>
                        <p>We're sorry what you were looking for. Please try another way</p>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
                </div>
        
                
              </div>
            
            <div class="container-fluid">
              <div *ngIf="(AnswerArray?.length || 0) > 0">
                <ng-container *ngFor="let data of AnswerArray,let i=index"  >
                  <!-- Display the question and answer -->
                  
                    <div *ngIf="data.type=='queryAnswer'&& !errorMessage">
                             
                    <div class="st-chat-current">
                        <div class="st-chat-inner-right-latest">
                        <div class="st-chat-inner-mn1n d-flex justify-content-end">
                          <div class="st-chat-message-latest qns-copy-btn">
                            <div class="copybtn-hover">
                              <button class="btn" type="button" (click)="copyQnToclipboard(data.question,data.conv_detail_id)">
                              <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
                              </button>
                              <span *ngIf="isQnCopied[data.conv_detail_id] " class="copied-message4">Copied to clipboard!</span>
                            </div>
                            <div class="st-qns-p2">{{data.question}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
              
                    <div class="st-chat-inner-left">
                      <div class="st-cht-lft-1i d-flex justify-content-start">
                        <div class="st-chat-message1">
                         
                          <div class="st-chat-message1-inner">
                            <div class="st-message-ai">
                              <div class="loader-chat" *ngIf="data.isLoading"><span>Processing</span><img src="../../assets/img/Circles-menu-3.gif"></div>
                              <h1 *ngIf="!data.allApisLoaded">{{data.sqlDescription}}</h1>

                              <div class="oi-data-tab-view1" *ngIf="!data.isLoading && data.tableData.length > 0">
                                <div class="oi-data-tab-menu1">
                                  <ul>
                                    <li [class.active]="data.activeTab === 'table'"
                                        (click)="onDataTabClick(data, 'table')">Table View</li>

                                    <li [class.active]="data.activeTab === 'chart'"
                                        (click)="onDataTabClick(data, 'chart')">Chart View</li>

                                    <li [class.active]="data.activeTab === 'smart'"
                                        (click)="onDataTabClick(data, 'smart')">Smart Analysis</li>
                                  </ul>

                                </div>
                              </div>




                              <div class="table-view1" *ngIf="data.activeTab === 'table'">
                              <div class="st-chat-tbl-dv" *ngIf="!data.isLoading" >
                                
                                <div class="table-responsive st-table-cht-mn" *ngIf="data.tableData.length > 0 ">
                                  <table cellspacing="2" cellpadding="2" >
                                    <tbody>
                                      <tr>
                                        <th  *ngFor="let column of data.displayedColumns"><div  class="chat-th">{{ column }}</div></th>
                                      </tr>
                                      <tr *ngFor="let row of paginatedTableData(data)">                          
                                        <td *ngFor="let column of data.displayedColumns">{{formatData( row[column])}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                               
                              </div>
                              </div>

                                                  <div class="chart-view" *ngIf="data.activeTab === 'chart'">
                      <div class="lt-loader" *ngIf="data.chartLoading"><img src="../../assets/img/loader-lt.gif">Loading chart...</div>

                      <div *ngIf="!data.chartLoading && data.hasValidChart">
                        <canvas baseChart
                                [data]="data.chartData.data"
                                [options]="data.chartData.options"
                                [type]="data.chartData.type"
                                style="min-height: 320px;">
                        </canvas>
                      </div>

                      <div *ngIf="!data.chartLoading && data.hasValidChart === false">
                        No chart data available.
                      </div>
                    </div>

                                  <div class="smart-analysis" *ngIf="data.activeTab === 'smart'">
                          <div class="lt-loader" *ngIf="data.analysisLoading"><img src="../../assets/img/loader-lt.gif"> Loading smart analysis...</div>

                          <div *ngIf="!data.analysisLoading && data.hasAnalysis">
                            <p [innerHTML]="sanitizeMessage(data.smartAnalysis, '')"></p>
                          </div>

                          <div *ngIf="!data.analysisLoading && data.hasAnalysis === false">
                            No smart analysis available.
                          </div>
                        </div>

                            </div>
                        
                        <!-- <div class="st-message-dt-lt">3:51 pm</div> -->
                      </div>
                      <div class="st-cht-lt-ai-btn" *ngIf="!data.isLoading && data.tableData.length > 0 ">
                        <div class="container-fluid">
                        <div class="row">
                         <div class="col-md-6">
                           <div class="st-chat-like-btn">
                             <button class="btn st-cht-copy" (click)="copyToClipboard(data,data.conv_detail_id)"
                             [pTooltip]="isCopied[i] ? 'Copied!' : 'Copy'"><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
                             <span *ngIf="isCopied[data.conv_detail_id] && !data.displaySQLmodal" class="copied-message">Copied to clipboard!</span></button>
                             <button class="btn" (click)="downloadTableData(data,null)">
                               <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg>
                             </button>           
              
                             <button  class="btn sql-drop-btn" [ngClass]="{'btn-sql-hover': data.displaySQLmodal}" (click)="openSQLmodal(data)">SQL Code <img [src]="data.displaySQLmodal ? '../../assets/img/caret-up.svg' : '../../assets/img/caret-down.svg'"></button>
                            
                           </div>
                         </div>
              
                         <div class="col-md-6">
                          <div class="st-chat-tble-pagination" *ngIf="data.pagination.totalPages>1 && data.activeTab === 'table'">
                            <div class="pagination-text"> Showing {{ data.pagination.currentPage }} out of {{ data.pagination.totalPages }}</div>
                            <div class="pagination-button">
                              <button
                                type="button"
                                class="btn btn-pagin-button"
                                [disabled]="data.pagination.currentPage === 1"
                                (click)="changeCurrentPage( i, 'prev')"  [ngClass]="{'active': data.pagination.currentPage != 1}"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><path d="M15 6l-6 6l6 6" /></svg>
                              </button>
                              <button
                                type="button"
                                class="btn btn-pagin-button"
                                [disabled]="data.pagination.currentPage  == data.pagination.totalPages"
                                (click)="changeCurrentPage(i, 'next')"  [ngClass]="{'active': data.pagination.currentColor != data.pagination.totalPages}"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><path d="M9 6l6 6l-6 6" /></svg>
                              </button>
                            </div>             
                            
                          </div>
                         </div>
                         
                        
                 
                          </div>
              
              
              
              
                          <div class="row" *ngIf="data.displaySQLmodal && data.tableData.length>0">
                            <div class="col-md-12">
                            <div class="sql-modal-custom">
                              <div class="sql-modal-header">SQL View <span><button class="btn sql-copy" type="button" [pTooltip]="isCopied[i] ? 'Copied!' : 'Copy'" (click)="copyToClipboard(data.sql_query,i)" ><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>
                              
                                <span *ngIf="isCopied[i]" class="copied-message2">Copied to clipboard!</span>
                              </button></span>
                               </div>
                              <div class="sql-content-mn">
                                <!-- <div class="modal-text-n">{{data.sql_query}}</div> -->
                                <pre><code class="modal-text-n" appHighlight> {{sqlFormatter}} </code></pre>
              
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    </div>
              
                    </div>
                </ng-container>
              </div>
              
            </div>
            </div>
          </div>

          <div class="data-insgt-bottom mt-auto">
              <div class="oidi-fixed-get">
                <div class="oidi-header-search box d-flex justify-content-start align-items-end">
                  <div class="oi-search-hd-main">
                    <textarea id="chatgpt" name="chatgpt" rows="1" autocomplete="off" class="oi-genrate-field" (input)="adjustInputWidth($event)" [disabled]="showtextbox" [style.height.px]="inputHeight" [(ngModel)]="query" maxlength="1000" (keydown.enter)="onEnterPress($event)" placeholder="Ask your query here.." autofocus ></textarea>
                  </div>
                  <div class="oi-head-serach-btn">
                    <button type="button" class="search-button" (click)="onEnterPress($event)"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z"></path><path d="M6.5 12h14.5"></path></svg></button>
                  </div>
                </div>
              </div>
              <div class="oi-get-answer-mn"><h2>Please type your question to receive an answer!</h2></div>
          </div>
          </div>
       
   

        </div>
        <div>
         
          
        </div>
      </div>
    </div>
  </div>
  </div>

</div>


<p-dialog header="Default Prompt" [(visible)]="showprompt"  [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onHidedefaultPrompt()">
    <div class="oi-ad-collect-mdl khdoc oi-know-bx-height">
        <ng-container *ngIf="modalloader else showdata">
            <div class="loader-knowledge">
                <img src="../../assets/img/loader.gif">
            </div>
        </ng-container>
        <ng-template #showdata>
              <div class="modal-content documnttext df-export-mn">
                <form [formGroup]="editForm">
                    <textarea formControlName="content" class="form-control" [innerHTML]="sanitizePromptMessage(editForm.value.content)" rows="10" cols="50"></textarea>
                </form>
                <div class="btn-mn-df-ex">
                <button class="btn btn-primary close" (click)="closePrompt()">Close</button>
                <button class="btn btn-primary" (click)="saveChanges()"  [disabled]="!isSaveEnabled">Save</button>
                </div>
              </div>
        </ng-template>
    </div>
</p-dialog>

<!-- modal -->
<p-dialog *ngIf="formReady" header="Database Connection Form" [(visible)]="visible" [style]="{width: '50vw'}" [modal]="true" [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false" (onHide)="onDialogHide()">
  <div class="oi-main-dshd uploadfile">
    <div class="container">
      <div class="mb-3">
        <form [formGroup]="connectionForm" (ngSubmit)="onSubmit()">
        <label for="db_type" class="form-label">Select Connection Type</label>
        <select id="db_type" class="form-select" formControlName="db_type" (change)="onDatabaseChange($event)">
          <option value="">-- Select Connection Type --</option>
          <option *ngFor="let db of dbControls" [value]="db.db_type">{{ db.db_type }}</option>
        </select>
          <div *ngIf="connectionForm.get('db_type')?.value">
           <label for="connection_name" class="form-label">Connection Name</label>
            <input
              id="connection_name"
              type="text"
              class="form-control"
              formControlName="connection_name"
              placeholder="Enter connection name"
            />
            <!-- Validation Error for connection_name -->
        <div *ngIf="connectionForm.get('connection_name')?.invalid && connectionForm.get('connection_name')?.touched" class="text-danger">
          Connection Name is required.
        </div>

          </div>

          <!-- Loop through controls to dynamically generate form inputs -->
          <div *ngFor="let control of controls" class="mb-3">
            <label [for]="control.name" class="form-label">{{ control.label }}</label>
            <input
              *ngIf="control.type !== 'checkbox'"
              [id]="control.name"
              [type]="control.type"
              [placeholder]="control.placeholder"
              class="form-control"
              [formControlName]="control.name"
            />

            <!-- Checkbox case -->
            <div class="form-check" *ngIf="control.type === 'checkbox'">
              <input type="checkbox" class="form-check-input" [id]="control.name" [formControlName]="control.name" />
              <label class="form-check-label" [for]="control.name">{{ control.label }}</label>
            </div>

            <!-- Validation error -->
            <div *ngIf="connectionForm.get(control.name)?.invalid && connectionForm.get(control.name)?.touched" class="text-danger">
              {{ control.label }} is required.
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-secondary me-2" (click)="resetForm()">Reset</button>
            <button type="submit" class="btn btn-primary" [disabled]="connectionForm.invalid">Connect</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</p-dialog>



<p-dialog header="Database Connection" [(visible)]="conn_visible" [style]="{width: '50vw'}" [modal]="true" [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false" (onHide)="onDialogHide()">
  
  <div class="dat-insight-modal">
    <div class="data-insight-database1">
      <p-dropdown [options]="databrickInstances" [(ngModel)]="selectedInstance" optionLabel="connection_name"
      (ngModelChange)="onInstanceSelect($event)"
      [showClear]="false" placeholder="Select your preferred database">
      <ng-template pTemplate="selectedItem">
        <div class="country-item country-item-value" *ngIf="selectedInstance">
          <div>{{selectedInstance.connection_name}}</div>
        </div>
      </ng-template>
      <ng-template let-country pTemplate="item">
        <div class="country-item">
          <div>{{country.connection_name}}</div>
        </div>
      </ng-template>
    </p-dropdown></div>

    <div class="data-ins-input-mn" *ngIf="showconnectionName">
      <input type="text" id="" class="form-control input-data" [ngClass]="{'st-error-border': !connectionName && showError}" [(ngModel)]="connectionName" autofocus (keydown.enter)="startConversation()"
      maxlength="30"  placeholder="Kindly provide a name for this conversation for future refrence">
    <button type="button" class="btn btn-enter" (click)="startConversation()">Press Enter</button>
    </div>

  </div>
  
 
</p-dialog> 

<p-dialog header="Delete Conversation?" [(visible)]="displayDeletemodal" [style]="{width: '35vw'}" [modal]="true" [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false" (onHide)="onDialogHide()">
  
  <div class="p-fluid modal-form-inner">
     <div class="field mdl-custom-fld">
       <!-- <label for="connectionName">SQL Code </label> -->
       <div class="modal-text-n">{{deleteMessage}}</div>
     </div>
 
     <div class="mdl-form-button">
       <button 
         pButton 
         type="button" 
         label="Cancel" 
         class="btn p-button-outlined cancelbtn"
         (click)="CancelDel()">
       </button>
       <button 
       pButton 
       type="button" 
       label="Delete" 
       class="btn p-button-outlined closebtn"
       (click)="ConfirmDelete()">
     </button>
       
     </div> 
     </div>
   
 </p-dialog>
<p-toast></p-toast>
